import { z } from 'zod';

export const socialMediaFormSchema = z.object({
  feed_twitter: z.boolean(),
});

export type SocialMediaFormData = z.infer<typeof socialMediaFormSchema>;
